import React from "react";
import PropTypes from "prop-types";

/**
 * Component to display an attachment with a link and optional remove button
 * @param {Object} props Component properties
 * @param {Object} props.attachment The attachment object to display
 * @param {Boolean} props.readOnly When true, the remove button will not be rendered
 * @param {Function} props.onClickRemove Function to handle remove button click
 */
const AttachmentListItem = ({ attachment, readOnly = false, onClickRemove }) => {
  // Handle the attachmentUrl logic
  let attachmentUrl = "#";
  if (attachment.existingFile) {
    attachmentUrl = attachment.url;
  } else if (attachment.file) {
    attachmentUrl = URL.createObjectURL(attachment.file);
  }

  return (
    <li
      key={attachment.id}
      className="d-flex align-items-center mb-1"
    >
      <a
        href={attachmentUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mr-2"
      >
        <i className="rkf rkf-file mr-1" />
        <span className="mr-2">{attachment.name}</span>
      </a>
      {!readOnly && (
        <button
          type="button"
          className="btn btn-link btn-sm text-danger p-0"
          onClick={() => onClickRemove(attachment.id)}
        >
          <i className="rkf rkf-trash" />
        </button>
      )}
    </li>
  );
};

AttachmentListItem.propTypes = {
  attachment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    file: PropTypes.object,
    existingFile: PropTypes.bool
  }).isRequired,
  readOnly: PropTypes.bool,
  onClickRemove: PropTypes.func
};

AttachmentListItem.defaultProps = {
  readOnly: false,
  onClickRemove: () => {}
};

export default AttachmentListItem;
